import React from 'react';

const QuestionFormIntermezzo = ({ children, show }) => {
  return <div>{children}</div>;
};

export default QuestionFormIntermezzo;
